import React from 'react';
import { Link } from 'react-router-dom';
import ClientLayout from '../../layouts/ClientLayout';

const CheckoutSuccess = () => {
    // Données de la commande (normalement récupérées depuis le contexte ou les props)
    const orderData = {
        orderNumber: 'CD404325185',
        paymentMethod: 'Paiement à la livraison',
        date: '26 juillet 2025',
        note: 'Payer en espèces à la livraison.',
        products: [
            {
                name: 'Apple Watch Series 9 GPS 45 mm, boitier en aluminium Midnight avec bracelet sport Midnight x 2;',
                seller: 'Djewno',
                price: 150500
            },
            {
                name: 'Apple AirPods Max - Rose - Rose x 2;',
                seller: 'Bacola',
                price: 150500
            }
        ],
        subtotal: 350500,
        shipping: 100500,
        total: 450500,
        // Nouvelles données pour les commandes individuelles
        individualOrders: [
            {
                orderNumber: 'C4044260',
                date: '26 juillet 2025',
                status: 'Traitement',
                total: '142,30 $ pour 2 articles'
            },
            {
                orderNumber: 'C4044260',
                date: '26 juillet 2025',
                status: 'Traitement',
                total: '142,30 $ pour 2 articles'
            }
        ],
        // Données des adresses
        billingAddress: {
            name: 'Mpoul Dodji',
            fullName: 'Stephane Franck',
            country: 'Togo',
            city: 'Lomé',
            email: 'happistephanell@gmail.com'
        },
        shippingAddress: {
            name: 'Mpoul Dodji',
            fullName: 'Stephane Franck',
            country: 'Togo',
            city: 'Lomé',
            email: 'happistephanell@gmail.com'
        }
    };

    return (
        <ClientLayout>
            <div className="flex-1 md:mx-8 lg:mx-16 mx-auto py-8">
                <div className="">
                    {/* Breadcrumbs */}
                    <div className="mb-4">
                        <nav className="text-sm text-gray-600">
                            <Link to="/" className="hover:text-gray-900">Accueil</Link>
                            <span className="mx-2">&gt;</span>
                            <Link to="/checkout" className="hover:text-gray-900">Vérifier</Link>
                            <span className="mx-2">&gt;</span>
                            <span className="text-gray-900">Commande reçue</span>
                        </nav>
                    </div>

                    {/* Order Confirmation Banner */}
                    <div className="mb-4">
                        <div className="bg-green-50 border-2 border-dashed border-green-300 rounded-lg p-4 text-center">
                            <p className="text-green-800 text-base font-medium">
                                Merci. Votre commande a bien été reçue.
                            </p>
                        </div>
                    </div>

                    {/* Order Summary Card */}
                    <div className="bg-gray-100 rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
                        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-500 mb-1">
                                    Numéro de commande
                                </label>
                                <p className="text-base font-semibold text-gray-900">{orderData.orderNumber}</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-500 mb-1">
                                    Mode de paiement
                                </label>
                                <p className="text-base font-semibold text-gray-900">{orderData.paymentMethod}</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-500 mb-1">
                                    Date
                                </label>
                                <p className="text-base font-semibold text-gray-900">{orderData.date}</p>
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-500 mb-1">
                                    Note
                                </label>
                                <p className="text-base font-semibold text-gray-900">{orderData.note}</p>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Main Content - 2/3 width */}
                        <div className="lg:col-span-2 space-y-6">


                            {/* Order Details Section */}
                            <div className="mt-4">
                                <h2 className="text-base font-semibold text-gray-900 mb-2">Détails de la commande</h2>

                                <div className="overflow-x-auto bg-gray-50 rounded-lg shadow-sm border border-gray-200">
                                    <table className='w-full'>
                                        <thead>
                                            <tr className='border'>
                                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 border">Produit</th>
                                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 border w-1/4">Détail</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className='border'>
                                                <td className="px-4 py-3 text-sm text-gray-900 border">Apple Watch Series 9 GPS 45 mm, boîtier en aluminium Midnight avec bracelet sport Midnight × 2 ; <br /> <span className='text-gray-900 font-medium'>vendeur : Djewno</span></td>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">150.500 FCFA</td>
                                            </tr>
                                            <tr className='border'>
                                                <td className="px-4 py-3 text-sm text-gray-900 border">Apple AirPods Max - Rose - Rose × 2 ; <br /> <span className='text-gray-900 font-medium'>vendeur : Bacola</span></td>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">150.500 FCFA</td>
                                            </tr>
                                            <tr className='border'>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">Total</td>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">350.500 FCFA</td>
                                            </tr>
                                            <tr className='border'>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">Expédition</td>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">100.500 FCFA</td>
                                            </tr>
                                            <tr className='border'>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">Mode de paiement</td>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">Paiement à la livraison</td>
                                            </tr>
                                            <tr className='border'>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">Total</td>
                                                <td className="px-4 py-3 text-sm text-gray-900 border font-medium">450.500 FCFA</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Individual Orders Table Section */}
                            <div className="">
                                <div className="overflow-x-auto bg-gray-50 rounded-lg shadow-sm border border-gray-200">
                                    <table className="w-full">
                                        <thead className="border-b border-gray-200">
                                            <tr className='border'>
                                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 border">Commande</th>
                                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 border">Date</th>
                                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 border">Statut</th>
                                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 border">Total</th>
                                                <th className="px-4 py-3 text-left text-sm font-medium text-gray-900 border"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            {orderData.individualOrders.map((order, index) => (
                                                <tr key={index} className="hover:bg-gray-50 border font-medium">
                                                    <td className="px-4 py-3 text-sm text-gray-900 border">{order.orderNumber}</td>
                                                    <td className="px-4 py-3 text-sm text-gray-900 border">{order.date}</td>
                                                    <td className="px-4 py-3 text-sm text-gray-900 border">{order.status}</td>
                                                    <td className="px-4 py-3 text-sm text-gray-900 border">{order.total}</td>
                                                    <td className="px-4 py-3 border">
                                                        <button className="rounded-full px-3 py-1 text-xs bg-gray-200 text-gray-800 font-medium hover:bg-gray-300">
                                                            Voir
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Addresses Section */}
                            <div className="">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {/* Billing Address */}
                                    <div>
                                        <h3 className="text-base font-semibold text-gray-900 mb-2.5">Adresse de facturation</h3>
                                        <div className="space-y-2 text-sm text-gray-500 font-medium">
                                            <p>{orderData.billingAddress.name}</p>
                                            <p>{orderData.billingAddress.fullName}</p>
                                            <p>{orderData.billingAddress.country}</p>
                                            <p>{orderData.billingAddress.city}</p>
                                            <p>{orderData.billingAddress.email}</p>
                                        </div>
                                    </div>

                                    {/* Shipping Address */}
                                    <div>
                                        <h3 className="text-base font-semibold text-gray-900 mb-2.5">Adresse de livraison</h3>
                                        <div className="space-y-2 text-sm text-gray-500 font-medium">
                                            <p>{orderData.shippingAddress.name}</p>
                                            <p>{orderData.shippingAddress.fullName}</p>
                                            <p>{orderData.shippingAddress.country}</p>
                                            <p>{orderData.shippingAddress.city}</p>
                                            <p>{orderData.shippingAddress.email}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Sidebar - 1/3 width */}
                        <div className="lg:col-span-1">
                            {/* Remark Card */}
                            <div className="bg-[#8A250E] rounded-lg shadow-sm border border-[#8A250E] p-6 mt-12">
                                <div className="flex items-center mb-4">
                                    <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center mr-3">
                                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                        </svg>
                                    </div>
                                    <h3 className="text-white font-bold text-lg">Remarque:</h3>
                                </div>
                                <p className="text-white text-sm leading-relaxed">
                                    Cette commande contient des produits de plusieurs fournisseurs. Nous l'avons donc divisée en plusieurs commandes fournisseurs. Chaque commande sera traitée indépendamment par son fournisseur respectif.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ClientLayout>
    );
};

export default CheckoutSuccess;
